// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__6MHPK","description":"MealItem_description__64-3N","price":"MealItem_price__kO2x-"};